<style scoped lang="scss">
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/plan/record/page" getKey="rows"
        :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('hedancaozuoren')">
            <el-input disabled v-model="$attrs.record.createByObject.nickname"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('hedanshijian')">
            {{dateFormat($attrs.record.createTime)}}
          </el-form-item>

          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
      </template>

    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
    </el-dialog>
  </div>
</template>
<script type="text/javascript">


export default {
  name: 'web_order_management_production_plan__customized_combination_record.vue',
  data() {
    return {

      columns: [{
        label: 'jihuadanhao',
        prop: 'no',
        width: 130
      }, {
        label: 'ERPgongdanhao',
        prop: 'erpNo',
        width: 130
      }, {
        label: 'chanpinbianma',
        prop: 'material.code',
        width: 130
      }, {
        label: 'chanpinmingcheng',
        prop: 'material.name'
      },
        {
          label: 'jihuashuliang',
          prop: 'quantity'
        },
        {
          label: 'yipaichanshuliang',
          prop: 'schedulingQuantity',
          width: 150
        }, {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'zhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            1: {
              color: '#E6A23C',
              text: this.$t('daipaichan')
            },
            2: {
              color: '#67C23A',
              text: this.$t('yipaichan')
            }
          },
        },
        {
          label: 'jihuakaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 150
        }, {
          label: 'jihuawanchengshijian',
          prop: 'endTime',
          type: 'time',
          width: 150
        }, {
          label: 'beizhu',
          prop: 'remark',
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        planId: this.$attrs.record.id,
        // orderBy: 'planStartTime,equipmentId asc',
      }
      this.yt.get(1);

      // this.yt.list = []
      // this.utils.event_hub.$on('PRODUCTION_MANAGEMENT_REFRESH', () => {
      // 	this.yt.get();
      // })
    }, 300)

  },
  methods: {
    dateFormat(time) {
      const t = new Date(time)
      // 日期格式
      const format = 'Y-m-d h:i:s'
      let year = t.getFullYear()
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1
      let day = t.getDate()
      let hours = t.getHours()
      let minutes = t.getMinutes()
      let seconds = t.getSeconds()
      month = month > 9 ? month : `0${month}`
      day = day > 9 ? day : `0${day}`
      hours = hours > 9 ? hours : `0${hours}`
      minutes = minutes > 9 ? minutes : `0${minutes}`
      seconds = seconds > 9 ? seconds : `0${seconds}`
      const hash = {
        'Y': year,
        'm': month,
        'd': day,
        'h': hours,
        'i': minutes,
        's': seconds
      }
      return format.replace(/\w/g, o => {
        return hash[o]
      })
    },
  },
};
</script>
